type DebugLogEntry = {
  ts: string;
  t: number;
  event: string;
  meta?: Record<string, unknown>;
};

const MAX_ENTRIES = 5000;
const entries: DebugLogEntry[] = [];

function push(event: string, meta?: Record<string, unknown>) {
  entries.push({
    ts: new Date().toISOString(),
    t: Date.now(),
    event,
    ...(meta && Object.keys(meta).length ? { meta } : {}),
  });
  if (entries.length > MAX_ENTRIES) {
    entries.splice(0, entries.length - MAX_ENTRIES);
  }
}

/** Append a structured debug line (no console). */
export function debugLog(event: string, meta?: Record<string, unknown>) {
  push(event, meta);
}

export function getDebugLogs(): readonly DebugLogEntry[] {
  return entries;
}

export function clearDebugLogs() {
  entries.length = 0;
}

/** Download all buffered lines as JSONL. */
export function downloadDebugLogs(filename?: string) {
  const body = entries.map((e) => JSON.stringify(e)).join('\n') + (entries.length ? '\n' : '');
  const blob = new Blob([body], { type: 'application/x-ndjson' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().replace(/[:.]/g, '-');
  a.href = url;
  a.download = filename || `pulse-debug-${stamp}.jsonl`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  return entries.length;
}

declare global {
  interface Window {
    _debugLogs?: typeof entries;
    _downloadDebugLogs?: typeof downloadDebugLogs;
    _clearDebugLogs?: typeof clearDebugLogs;
  }
}

/** Install window helpers once (safe to call repeatedly). */
export function installDebugLogGlobals() {
  window._debugLogs = entries;
  window._downloadDebugLogs = downloadDebugLogs;
  window._clearDebugLogs = clearDebugLogs;
}
